// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sazv","left":"styles_left__3R6CB"};